import React, { useEffect, useState } from "react";
import axios from "axios";
import { useRequestContext } from "../../hooks/useRequest";
import { Collapsible, PdfShower } from "../../../components";
import { SectionTrigger } from "../../../orderManagement/molecules/SectionTrigger";
import { pxSellSectionId } from "../../v2/sectionConfig";
import { AgreementFooter } from "./AgreementFooter";

export function PurchasingAgreement({ step, idx, navigateTo }) {
  const [fileId, setFileId] = useState(null);
  // Agreements are sensitive (seller PII), so the backend gates
  // GET /api/pdfs/{id}; a token-less <object> request 403s. It now returns a
  // temporary signed URL that satisfies the gate — render that. Keep the
  // numeric fileId for the send-agreement call below.
  const [pdfUrl, setPdfUrl] = useState(null);
  const {
    getContext,
    onPurchaseAgreementSend,
    toggleStep,
    refreshRequest,
  } = useRequestContext();
  // Step-aware so a PX group's per-sell-request instance generates the
  // agreement for ITS trade-in, not for the parent order request.
  const { request } = getContext(idx, step);
  const [isLoading, setIsLoading] = useState(false);

  const getPDF = async () => {
    const { data } = await axios.get(`/api/requests/${request.id}/pdf-purchase`);
    setFileId(data.file_id);
    setPdfUrl(data.signed_url || null);
    // Backend stamps purchasing_agreement_sent_at on the first PDF
    // generation — refetch so the V2 sidebar reflects it immediately.
    await refreshRequest?.();
  };

  // Suffixed per trade-in inside a PX slot; the static id elsewhere.
  const advanceToPayments = () =>
    navigateTo?.(pxSellSectionId("sell_payments", step?.pxSellIdx));

  const onSave = () => {
    onPurchaseAgreementSend();
    advanceToPayments();
  };

  const onSend = async () => {
    setIsLoading(true);
    await axios.post(
      `/api/requests/${request.id}/send-purchase-agreement/${fileId}`
    );
    setIsLoading(false);
    onPurchaseAgreementSend();
    advanceToPayments();
    await refreshRequest?.();
  };

  useEffect(() => {
    getPDF();
  }, []);

  return (
    <Collapsible
      trigger={<SectionTrigger label={step.label} icon="doc" />}
      open={step.open}
      handleTriggerClick={() => toggleStep(idx)}
      testId="confirm-request"
    >
      <div className="mt-2">
        <PdfShower fileId={pdfUrl || fileId} />
      </div>
      <AgreementFooter
        feature="purchasing"
        className="my-2"
        onSave={onSave}
        onSend={onSend}
        sending={isLoading}
      />
    </Collapsible>
  );
}
